const List = () => import(/* webpackChunkName: "HuntingTicketOrders" */ 'RootDir/modules/HuntingTickets/HuntingTicketOrder/List.vue');
const Create = () => import(/* webpackChunkName: "HuntingTicketOrders" */ 'RootDir/modules/HuntingTickets/HuntingTicketOrder/Create.vue');
const ShowWrapper = () => import(/* webpackChunkName: "HuntingTicketOrders" */ 'RootDir/modules/HuntingTickets/HuntingTicketOrder/ShowWrapper.vue');

export default [
  {
    path: 'list',
    name: 'hunting-ticket-orders',
    component: List,
  },
  {
    path: 'create',
    name: 'create-hunting-ticket-order',
    component: Create,
  },
  {
    path: 'show/:orderId',
    name: 'show-hunting-ticket-order',
    props: true,
    component: ShowWrapper,
  },
];
